// plainClick opens a link inside the app on an ordinary click, and leaves
// Cmd-click, Ctrl-click and the like to the browser, so they still open a new tab.
export function plainClick(navigate, path) {
  return (e) => {
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    navigate(path);
  };
}
